import React from 'react';
import DemoCodeReader from '../app_submitter/components/CodeReader/DemoCodeReader';

import './QRGenerator.css';

import { useContext, useState } from 'react';
import { Routes, Route, Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';

import Layout from '../app_submitter/components/Layout/Layout';
import UserProfile from '../app_submitter/components/Profile/UserProfile';
import AuthPage from '../app_submitter/Pages/AuthPage';
import DemoLoginPage from '../app_submitter/Pages/DemoLoginPage';
import HomePage from '../app_submitter/Pages/HomePage';
import SubmitPage from '../app_submitter/Pages/SubmitPage';
//import AuthContext from '../app_submitter/store/auth-context';
import { logout, isLoggedIn } from '../components/util/auth';
import ConnectionMonitor from '../app_submitter/components/ConnectionMonitor/ConnectionMonitor';

import styles from './Submitter.module.css';

const PrivateRoute = () => {
  //const authCtx = useContext(AuthContext);
  //return authCtx.isLoggedIn ? <Outlet /> : <Navigate to="/auth" />;
  return isLoggedIn() ? <Outlet /> : <Navigate to="/auth" />;
}

const RequireAuth = (props) =>{
  //const authCtx = useContext(AuthContext);
  let location = useLocation();

  //if (!authCtx.isLoggedIn) {
  if ( !isLoggedIn() ) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/submit/auth" state={{ from: location }} />;
  }

  return props.children;
}


function Submitter( props ) {
  //const authCtx = useContext(AuthContext);
  const [redirect, setRedirect] = useState(false);
  const navigate = useNavigate();

  const logoutHandler = () => {
    logout();
    // optional: redirect the user
    // navigate('/submit/auth')
    setRedirect(true);
    //return <Navigate to="/submit/auth" />;
  };

  //console.log('inside Submitter', authCtx.isLoggedIn);
  //console.log('inside Submitter', isLoggedIn() );
  if(redirect){
    console.log('trying to redirect')
    setRedirect(false);
    //return <Navigate to="/submit/auth" />;
    navigate('/submit/auth')
    return
    console.log('trying and trying  to redirect')
  };

  let menu = '';
  //if ( authCtx.isLoggedIn ){
  if ( isLoggedIn() ){
    menu = [
      { label: 'Befunde und Nachrichten', 
        link:  '/submit' 
      },
      { label: 'Profil', 
        link:  '/submit/profile' 
      },
      { label: 'Neuer Befund', 
        link:  '/submit/new' 
      },
      { label: 'Logout',
        callback: logoutHandler 
      }
    ]
  } else {
    menu = [
      { label: 'Login', 
        link: '/submit/auth' 
      }        
    ]
  }
  
//  {!authCtx.isLoggedIn && (
//    <Route path='/submit/auth' element={<AuthPage />} />
//  )}
  return (
    <Layout menu={menu}>
      <Routes>
        <Route exact path='/submit/demo' element={
          <DemoLoginPage/>
        } />

          <Route path='/submit/auth' element={<AuthPage />} />

        <Route exact path='/submit/profile' element={
          <RequireAuth>
            <UserProfile />
          </RequireAuth>
        } />

        <Route exact path='/submit' element={
          <RequireAuth>
            <HomePage config={ props.rails.config } />
          </RequireAuth>
        } />

        <Route exact path='/submit/new' element={
          <RequireAuth>
            <SubmitPage config={ props.rails.config } />
          </RequireAuth>
        } />

        <Route exact path='/submit/cmon' element={
            <ConnectionMonitor />
        } />
      </Routes>
    </Layout>
  );
}

//<Route path='/profile' element = { authCtx.isLoggedIn ? <Outlet /> : <Navigate to='/auth' />} >
//<Route path='/profile' element={<UserProfile />}/>
//</Route>

//<Route exact path='/profile' element={<PrivateRoute/>}>
//            <Route exact path='/profile' element={<UserProfile/>}/>
//          </Route>

//<Route path='*'>
//<Navigate to='/' />
//</Route>

function SubmitterOld() {
  return (
    <div className="App"> 
      <h1>QR Reader</h1>     
      <DemoCodeReader />
    </div>
  );
}

export default Submitter;

